import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { CircularProgress } from '@material-ui/core';
import HttpService from '../../../Services/HttpServices';

class AutoLogin extends Component {
    componentDidMount() {
        this.tryAutoLogin();
    }

    onSuccessLogin(data, link) {
        const address = {};
        sessionStorage.setItem('user', JSON.stringify(data.session));
        sessionStorage.setItem('User', JSON.stringify(data.session));
        sessionStorage.setItem('ExpiringMemorial', JSON.stringify(data.expiring_memorial || false));
        let userId = null;
        try {
            userId = data.session.userdata.user_id;
        } catch (e) {
            userId = null;
        }
        let time;
        try {
            time = data.session.userdata.notificationPreference;
        } catch (e) {
            time = null;
        }
        if (userId) {
            HttpService('get', 'contactData', userId).then(result => {
                const { data } = result;
                if (data.response === 'success') {
                    sessionStorage.setItem('userContactPreference', JSON.stringify({ zone: data.data, time }));
                }
            });
        }
        if (data.session.userdata.addresses?.length > 0) {
            const addr = data.session.userdata.addresses.slice(-1)[0];
            address.address = addr.address;
            address.number = addr.number;
            address.region = addr.region;
            address.city = addr.location;
            address.province = addr.province;
            address.cap = addr.cap;
            address.nationality = addr.nationID;
            address.complete_address = addr.completeAddress;
        }
        sessionStorage.setItem('UserAddress', JSON.stringify(address));

        window.scrollTo(0, 0);
        if (link) {
            window.location.href = link;
        } else {
            this.props.history.push('/home?name=&region=&province=&location=&cap=&page=0#newLogin');
        }
    }

    async tryAutoLogin() {
        try {
            //DigitalMemorial App: Get Token and Link
            const token = window?.AndroidApp?.getToken?.();
            const link = window?.AndroidApp?.getLink?.();
            if (!token) {
                if (link) { window.location.href = link; }
                else { this.props.history.push('/home'); }
                return;
            }

            //Login with Token
            const bodyData = { token };
            const data = await HttpService('post', 'autologin', bodyData);
            if (data?.result !== 'fail' && data?.session?.userdata?.permissions) {
                this.onSuccessLogin(data, link);
            } else {
                if (link) { window.location.href = link; }
                else { this.props.history.push('/home'); }
            }
        } catch (err) {
            console.error('Errore auto-login:', err);
            const link = window?.AndroidApp?.getLink?.();
            if (link) { window.location.href = link; }
            else { this.props.history.push('/home'); }
        }
    }

    render() {
        return (
            <>
                <div
                    style={{ minHeight: window.innerHeight - 100 }}
                    className="login-page columns is-mobile is-centered login-media-fix"
                >
                    <div
                        style={{
                            height: 400,
                            width: '100%',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}
                    >
                        <CircularProgress style={{ color: "#000000" }} />
                    </div>
                </div>
            </>
        );
    }
}

export default withRouter(AutoLogin);